module.exports = __webpack_public_path__ + "static/media/asteroid.836505e8.png";